import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  id: string;
  data: any; //TODO: fix type;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  id: "",
  data: null,
};

const getListArriveLateDetailSlice = createSlice({
  name: "getListArriveLateDetail",
  initialState,
  reducers: {
    setArriveLateDetailId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    resetListArriveLateDetailId: (state) => {
      state.id = "";
    },
    getListArriveLateDetailStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getListArriveLateDetailSuccess: (state, action: PayloadAction<any>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },

    getListArriveLateDetailFailed: (state, action: PayloadAction<string>) => {
      state.status = ReduxStateType.ERROR;
      state.data = action.payload;
    },
    resetListArriveLateDetail: () => {
      return { ...initialState };
    },
  },
});

export const {
  setArriveLateDetailId,
  resetListArriveLateDetailId,
  getListArriveLateDetailStart,
  getListArriveLateDetailSuccess,
  getListArriveLateDetailFailed,
  resetListArriveLateDetail,
} = getListArriveLateDetailSlice.actions;

export default getListArriveLateDetailSlice.reducer;
